import { render, staticRenderFns } from "./RealmLogoImage.vue?vue&type=template&id=945fb092"
import script from "./RealmLogoImage.vue?vue&type=script&lang=js"
export * from "./RealmLogoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports